export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11034.cbd8b63c.jpg";